import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { Colors } from "../utils/style";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";

type Prop = {
  title: string;
  description?: string;
  logo: string;
  children?: ReactNode;
  width?: string;
  titleHeight?: string;
  handleOnClick?: () => void;
};
function UseCaseCardComponent(props: Prop) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation("UseCaseCardComponent");

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleOnClick = () => {
    props.handleOnClick ? props.handleOnClick() : navigate("/useCaseDetails");
  };
  return (
    <>
      <Card
        style={{
          borderRadius: "10px",
          borderColor: isHovered ? "green" : "",
          height: "100%",
        }}
        onMouseOver={handleHover}
        onMouseLeave={handleMouseLeave}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "1rem",
          }}
        >
          <Card.Img
            variant="top"
            src={props.logo}
            style={{ width: "200px", height: "200px" }}
          />
        </div>
        <Card.Body
          style={{
            backgroundColor: Colors.GRAY,
            borderRadius: "0px 0px 10px 10px",
          }}
        >
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ height: "5rem" }}>{props.description}</Card.Text>
          <Button variant="success" onClick={handleOnClick}>
            {
              t("ViewAnalysisButton")
            }
          </Button>
        </Card.Body>
      </Card>
    </>
  );
}

export default UseCaseCardComponent;
